export const LINKS = {
    POWERED_BY:
        'https://georide.fr/?utm_source=ducati&utm_medium=website&utm_campaign=60.000km-tour',
};
